import React from "react"
import { Link, graphql } from "gatsby"
import { getImage } from "gatsby-plugin-image"
import { Helmet } from "react-helmet"
import Layout from "../../components/Layout/Layout"
import Title from "../../components/Title/Title"
import BreadcrumbBar from "../../components/BreadcrumbBar/BreadcrumbBar"
import TxtImg from "../../components/TxtImg/TxtImg"
import Testimonial from "../../components/Testimonial/Testimonial"
import Cards from "../../components/Cards/Cards"
import Card from "../../components/Card/Card"

function Osteopathy({ data }) {
    const parentPages = [{name: "Home", path: "/"}]
    const image = getImage(data.image)

    return (
        <Layout>
            <Helmet>
                <meta charSet="utf-8" />

                <title>Osteopathy | Desborough Osteopathy</title>
                <html lang="en" />
            </Helmet>
            <Title title="Osteopathy" />
            <BreadcrumbBar currentPage="Osteopathy" parentPages={parentPages} />
            <section>
                <div style={{width: 'min(90%, 800px)', margin: 'auto'}}>
                    <h2>What is Osteopathy?</h2>
                    <p>Aliqua incididunt aute velit ullamco. Amet nulla duis nisi id ea non cillum dolor est sit commodo sunt deserunt eu. Irure in aute amet culpa et fugiat officia aute consequat et officia ut occaecat. Fugiat esse aute voluptate eu aute proident enim excepteur deserunt id. Aliquip minim culpa enim sint. Pariatur commodo amet duis ex occaecat ad magna magna proident velit nostrud Lorem laborum. Laborum eu cillum velit aliqua tempor quis.</p>
                    <p>Aute ad labore exercitation commodo enim duis elit Lorem incididunt. Consequat commodo laboris incididunt voluptate quis eiusmod cillum commodo eiusmod ipsum. Reprehenderit qui et voluptate sit officia. Id qui quis ipsum esse ad proident dolore officia incididunt commodo est incididunt tempor enim.</p>
                    <p>Labore ipsum enim qui veniam ipsum in ut exercitation esse dolor. Minim exercitation qui ad qui. Excepteur eu consectetur veniam proident dolor ea anim qui magna consectetur magna ex ea sit. Aliquip voluptate aliquip laboris ea elit anim amet incididunt.</p>
                </div>
            </section>
            <section style={{backgroundColor: 'var(--neutral-100)'}}>
                <TxtImg imgSrc={image} imgAlt="">
                    <p>Ipsum culpa est laboris eu eu non ut sunt. Sit irure amet sunt velit cillum dolore mollit laboris et minim id. Adipisicing elit ipsum mollit in veniam consequat nulla exercitation ullamco duis. Nostrud commodo sit dolor consectetur adipisicing eiusmod nostrud irure.</p>
                    <p>Labore proident sint velit non Lorem laborum enim proident. Officia anim ea eu aliquip fugiat do ad elit nisi eu. Eiusmod nisi quis minim ipsum voluptate amet ea cillum et. Duis enim sit incididunt excepteur veniam. Ipsum ullamco commodo duis officia dolore labore. Pariatur ex in dolor aliqua tempor duis ad minim aliqua et ullamco ut ad et.</p>
                </TxtImg>
            </section>
            <section>
                <Testimonial quote="Dolor magna ea aliquip ipsum non sit reprehenderit deserunt adipisicing sint excepteur laboris fugiat minim. Aliqua mollit deserunt quis nostrud." />
            </section>
            <section>
              <div style={{width: 'min(90%, 1200px)', margin: 'auto'}}>
                <h2 style={{textAlign: 'center'}}>More about Osteopathy at Desborough Osteopaths</h2>
                <Cards>
                  <Card
                    imgSrc={image}
                    imgAlt=""
                    heading="Cranial Osteopathy"
                    description="Non commodo aliqua in ex occaecat nulla amet esse voluptate aliqua."
                    linkType="text"
                    linkTo="/osteopathy/cranial-osteopathy/"
                    linkText="Read about Cranial Osteopathy"
                  />
                  <Card
                    imgSrc={image}
                    imgAlt=""
                    heading="What to expect"
                    description="Non commodo aliqua in ex occaecat nulla amet esse voluptate aliqua."
                    linkType="text"
                    linkTo="/osteopathy/what-to-expect/"
                    linkText="Find out what to expect"
                  />
                  <Card
                    imgSrc={image}
                    imgAlt=""
                    heading="Appointments"
                    description="Non commodo aliqua in ex occaecat nulla amet esse voluptate aliqua."
                    linkType="text"
                    linkTo="/appointments/"
                    linkText="Book your appointment now"
                  />
                </Cards>
              </div>
            </section>
        </Layout>
    )
}

export const query = graphql`
  query {
    image: file(relativePath: {eq: "hero-banner.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          width: 1000,
          placeholder: BLURRED,
          formats: WEBP
        )
      }
    }
  }
`

export default Osteopathy